import React from 'react';
import { Provider, connect } from 'react-redux';
import store from './configureStore';

const AppProvider = (Component) => () => (
  <Provider store={store}>
    <Component />
  </Provider>
);

export default AppProvider;



// WEBPACK FOOTER //
// ./assets/scripts/redux/Provider.js